import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/product-intech-rv")({
  component: () => <Outlet />,
});
